import { render, staticRenderFns } from "./MyProfilePage.vue?vue&type=template&id=aaacc2b8&scoped=true&"
import script from "./MyProfilePage.vue?vue&type=script&lang=ts&"
export * from "./MyProfilePage.vue?vue&type=script&lang=ts&"
import style0 from "./MyProfilePage.vue?vue&type=style&index=0&id=aaacc2b8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aaacc2b8",
  null
  
)

export default component.exports